import React from 'react';
import './Piazzamento.css';

/**
 * Il piazzamento di una edizione.
 *
 * È l'unico elemento della sezione che si concede un colore fuori palette, e lo fa perché
 * in un archivio di tornei il podio è la cosa che la gente cerca: dare peso visivo a primo,
 * secondo e terzo trasforma una colonna di numeri in qualcosa su cui l'occhio può scorrere.
 * Dal quarto in giù il numero resta un numero, altrimenti l'accento non distinguerebbe più
 * niente.
 *
 * Un piazzamento assente non è uno zero: una edizione senza formula, o una squadra che non
 * compare in nessuna fase, non ha una posizione, e mostrare "—" è l'unica cosa vera.
 */
export default function Piazzamento({ posizione }) {
  if (!posizione) return <span className="piazz-assente" title="Piazzamento non disponibile">—</span>;

  const podio = posizione <= 3 ? ` piazz-podio piazz-p${posizione}` : '';
  return <span className={`piazz${podio}`}>{posizione}º</span>;
}
